/**
 * Debug logging utility for conditional console output
 * Set DEBUG_TEAM_LOGS to true to enable team-related debug logs
 */

// Set this to true to enable debug logging for team functionality
const DEBUG_TEAM_LOGS = true;

/**
 * Conditional debug logger
 * @param module - Module/component name for identification
 * @param message - Log message
 * @param data - Optional data to log
 */
export const debugLog = (module: string, message: string, data?: any): void => {
  if (!DEBUG_TEAM_LOGS) {
    return;
  }

  const timestamp = new Date().toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
  const prefix = `[${timestamp}] ${module}`;

  if (data !== undefined) {
    console.log(`${prefix} ${message}`, JSON.stringify(data, null, 2));
  } else {
    console.log(`${prefix} ${message}`);
  }
};
